import { render, staticRenderFns } from "./InventoryAgingSummary.vue?vue&type=template&id=a06f5e72"
import script from "./InventoryAgingSummary.vue?vue&type=script&lang=js"
export * from "./InventoryAgingSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports